import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Loader from '../../_common/loader'
import AccessoryItem from './accessoryItem'
import LocationsModal from '../../_common/modals/LocationsModal'
import CustomerPartModal from '../../_common/modals/CustomerPartModal'
import queryString from 'query-string'
import SubstituteLink from 'pageComponents/_common/SubstituteLink'
import NotifyMeButton from './notifyMe'
import SkeletonLoader from './SkeletonLoader'
import RelatedTo from './RelatedTo'
import TechSpecs from './TechSpecs'
import Accessories from './Accessories'
import ItemLinks from './ItemLinks'
import { anchorLink } from 'pageComponents/_common/helpers/generalHelperFunctions'

const DivDetails = styled.div`
	flex: 1;
	max-width: 100%;
	padding: 0 16px;
`

const Row = styled.div`
	display: flex;
	align-items: center;
`

const P = styled.p`
	margin: 0;
`

const DivAccessoryItems = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
`

const PItemExtendedDescription = styled.p`
	font-size: 16px;
`
const Pprice = styled.p`
	color: #328EFC;
	font-size: 18px;
	font-weight: 700;
    padding: 0 0 4px 4px;
	margin: 0;
`

const TABLE = styled.table`
	margin-top: 20px;
`

const TR2 = styled.tr`
	border-top: 1px lightgrey solid;
	border-bottom: 1px lightgrey solid;
`

const TDGrey = styled.td`
	text-align: right;
	padding: 4px 8px 4px 24px;
	font-weight: 500;
	background-color: whitesmoke;
`

const H3 = styled.h3`
  font-size: 18px;
  margin: 0;
`

const TDWhite = styled.td`
    padding: 4px 24px 4px 8px;
`

const IMG = styled.img`
	opacity: 0.6;
`

const StrikeThrough = styled.span`
    text-decoration: line-through;
`

const ACall = styled.a`
	color: #328EFC;
	font-weight: 700;
	padding: 0 4px;
`

const DivOtherActions = styled.div`
    display: flex;
    flex-direction: row;
`

const LinkBtn = styled(Link)`
    text-decoration: none!important;
`
const Ul = styled.ul`
    margin-bottom: 20px;
`

const ButtonBlue = styled.button`
    color: white;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: 'white !important';
    background: #0368e0;
    background: linear-gradient(to top left, #0368e0, #328efc);
    padding: 4px 12px;
    box-shadow: 1px 1px 2px black;
    font-size: 12px;
    font-weight: 600;
    border: none;
    margin: 5px;
    svg {
        margin-right: 5px;
    }
    &:hover {
        color: white;
        text-decoration: none;
    }
`

const AvailabilityRow = styled.div`
	width: 100%;
	display: flex;
	color: #000;
	padding: 0 5px;
	font-size: 12px;
	font-family: Arial, sans-serif;
    gap: 5px;
`

const Availability = styled.p`
	margin: 0;
	font-size: 13px;
`

export default function ItemDetailPage(props) {
    const {
        itemDetails,
        accessoryItems,
        accessoryItemsInfo,
        accessoryItemPrices,
        itemAvailability,
        unitOfMeasure,
        unitPrice,
        handleAddedToCart,
        setSelectedCustomerPartNumberId,
        selectedCustomerPartNumberId,
        customerPartOptions,
        loadedCalls,
        invMastUid,
        itemInfo,
        brandSearchLink,
        quantityAvailableToMake
    } = props

    useEffect(() => {
        window.scrollTo({ top: 0 })
    }, [])

    const [onOrder, setOnOrder] = useState(null) /*How many are on order, when there are none in stock*/

    const isDiscontinued = itemDetails?.isDiscontinued

    const infoUrl = buildInfoUrl()

    function buildInfoUrl() {
        const urlArr = window.location.toString().split('/').slice(3)
        urlArr[0] = 'productinfo'
        return `/${urlArr.join('/')}`
    }

    function cpnModal_onSelectedChanged(value) {
        if (value === '-1') {
            setSelectedCustomerPartNumberId(0) // Reset Dropdown
        } else {
            setSelectedCustomerPartNumberId(Number(value))
        }
    }

    function cpnModal_onClearSelected() {
        setSelectedCustomerPartNumberId(0)
    }

    const FeatureItems = itemDetails?.itemFeatures?.map((elem, idx) => <li dangerouslySetInnerHTML={{ __html: elem.text }} key={idx}></li>)

    const SpareParts = accessoryItems?.filter(a => a.type === 1)
    const AccessoryItems = accessoryItems?.filter(a => a.type === 2)
    const SubstituteItems = accessoryItems?.filter(a => a.type === 3)
    const bom = accessoryItems?.filter(a => a.type === 4)

    useEffect(() => {
        if (loadedCalls.length === 3) {
            const hash = queryString.parse(window.location.hash)
            if (Object.keys(hash).length) {
                const id = Object.keys(hash)[0]
                document.getElementById(id)?.scrollIntoView()
            }
        }
    }, [loadedCalls])

    const OtherActions = (props) => {
        const {
            SubstituteItems,
            onOrder
        } = props

        return <DivOtherActions>
            {!!onOrder && <NotifyMeButton onOrder={onOrder} />}
            {SubstituteItems?.length > 0 && <SubstituteLink className='scrollToLink' href='#sub' />}
            {bom.length > 0 && itemAvailability?.availability === 0 && (
                <LinkBtn to={infoUrl}>
                    <ButtonBlue>Bill of Materials</ButtonBlue>
                </LinkBtn>
            )}
        </DivOtherActions>
        
    }

    useEffect(() => {
        anchorLink()
    }, [OtherActions])

    const bomLink = `/productinfo/${itemDetails?.itemCodeUrlSanitized || encodeURIComponent(itemDetails?.itemCode)}/${itemDetails?.invMastUid}${selectedCustomerPartNumberId ? `/${selectedCustomerPartNumberId}` : ''}`;

    if (!itemDetails) {
        return (<Loader />)
    } else if (!itemDetails?.invMastUid) {
        return (<p>No item found</p>)
    } else {
        return (
            <DivDetails>
                <PItemExtendedDescription dangerouslySetInnerHTML={{ __html: itemDetails?.extendedDesc }} />

                {!isDiscontinued && (
                    <>
                        <Row>
                            <Pprice>{!unitPrice ? <ACall href="tel:+18009997378">Call for Price</ACall> : `$${unitPrice.toFixed(2)}`}</Pprice>
                            {!!unitPrice && <P> /{unitOfMeasure}</P>}
                        </Row>

                        <LocationsModal
                            invMastUid={itemDetails?.invMastUid}
                            availabilityInfo={itemAvailability}
                            unitPrice={unitPrice}
                            isAssembly={itemDetails?.isAssembly}
                            setOnOrder={setOnOrder}
                        />
                    </>
                )}

                {(itemAvailability?.Availability && itemAvailability.availability === 0 && quantityAvailableToMake > 0) && (
                    <AvailabilityRow>
                        <Availability>
                            Components Available To Make:
                        </Availability>
                        <Link to={bomLink}>{quantityAvailableToMake}</Link>
                    </AvailabilityRow>
                )}

                <OtherActions SubstituteItems={SubstituteItems} onOrder={onOrder} />

                <TABLE>
                    <tbody>

                        {itemDetails?.brand?.logoLink && <TR2><TDGrey><H3>Manufacturer</H3></TDGrey><TDWhite><IMG width='100px' src={itemDetails?.brand?.logoLink} /></TDWhite></TR2>}
                        <TR2><TDGrey><H3>Item ID</H3></TDGrey><TDWhite>{itemDetails?.itemCode}</TDWhite></TR2>
                        <TR2><TDGrey><H3>Manufacturer Part #</H3></TDGrey><TDWhite>{itemDetails?.mfgPartNo}</TDWhite></TR2>
                        <TR2><TDGrey><H3>AHC Part #</H3></TDGrey>
                            {isDiscontinued ? (
                                <TDWhite><StrikeThrough>{itemDetails?.invMastUid}</StrikeThrough> Discontinued</TDWhite>
                            ) : (
                                <TDWhite>{itemDetails?.invMastUid}</TDWhite>
                            )}

                        </TR2>
                        {itemDetails?.nsn && <TR2><TDGrey><H3>NSN #</H3></TDGrey>
                            <TDWhite>{itemDetails.nsn}</TDWhite>
                        </TR2>}

                        {!!customerPartOptions?.length && (
                            <TR2>
                                <TDGrey><H3>Customer Part #</H3></TDGrey>
                                <TDWhite>
                                    <CustomerPartModal
                                        invMastUid={invMastUid}
                                        customerPartNumbers={customerPartOptions}
                                        selectedCustomerPartNumberId={selectedCustomerPartNumberId}
                                        onSelectedChanged={cpnModal_onSelectedChanged}
                                        onClearSelected={cpnModal_onClearSelected}
                                    />
                                </TDWhite>
                            </TR2>
                        )}

                        <TR2>
                            <TDGrey><H3>Unit Size</H3></TDGrey>
                            <TDWhite>{itemDetails?.unitSizeMultiple}</TDWhite>
                        </TR2>

                        <TR2>
                            <TDGrey><H3>Brand</H3></TDGrey>
                            <TDWhite>
                                <Link to={itemDetails?.brand?.brandPromoLink || brandSearchLink}>
                                    <div>{itemDetails?.brand?.name}</div>
                                </Link>
                            </TDWhite>
                        </TR2>
                        {bom?.length > 0 && (
                            <TR2>
                                <TDGrey>
                                    <H3>BOM Available</H3>
                                </TDGrey>
                                <td>
                                    <Link to={infoUrl}>
                                        View Bill of Materials
                                    </Link>
                                </td>
                            </TR2>
                        )}
                    </tbody>
                </TABLE>

                <hr />

                {!!FeatureItems?.length && (
                    <section>
                        <h2 id='feature'>Features</h2>
                        <Ul>{FeatureItems}</Ul>
                    </section>
                )}

                {!!itemDetails?.itemTechSpecs?.length && (
                    <TechSpecs {...{ itemDetails }} />
                )}

                {itemDetails?.itemLinks?.length > 0 &&
                    <section>
                        <h2>Links</h2>
                        <ItemLinks links={itemDetails?.itemLinks} />
                    </section>}
                {SpareParts?.length > 0 &&
                    <section>
                        <h2 id='spare'>Spare Parts</h2>
                        <Accessories
                            items={SpareParts}
                            info={accessoryItemsInfo}
                            prices={accessoryItemPrices}
                            handleAddedToCart={handleAddedToCart}
                        />
                    </section>
                }

                {AccessoryItems?.length > 0 &&
                    <section>
                        <h2 id='accessory'>Accessory Items</h2>
                        <Accessories
                            items={AccessoryItems}
                            info={accessoryItemsInfo}
                            prices={accessoryItemPrices}
                            handleAddedToCart={handleAddedToCart}
                        />
                    </section>
                }

                {SubstituteItems?.length > 0 &&
                    <section>
                        <h2 id='sub'>Substitute Items</h2>
                        <Accessories
                            items={SubstituteItems}
                            info={accessoryItemsInfo}
                            prices={accessoryItemPrices}
                            handleAddedToCart={handleAddedToCart}
                        />
                    </section>
                }

                {itemDetails?.hasRelations && (
                    <section>
                        <h2 id='relatedto'>Related To</h2>
                        <RelatedTo
                            {...{ invMastUid }}
                        />
                    </section>
                )}

                {!itemInfo && <SkeletonLoader />}
            </DivDetails>
        )
    }
}
